import {Component, HostListener, OnDestroy, OnInit, VERSION} from '@angular/core';
import {environment} from '../environments/environment';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {Configparams} from './model/configmodel/configparams'
import {ConfigService} from './services/config.service';
import {Meta, Title} from '@angular/platform-browser';
import {Subscription} from 'rxjs';

/** Class for the app component that is bootstrapped to run the application
 */
@Component({
	selector: 'body',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
	/** string used to hold the url for the skipToMain link */
	skipToMain: string;
	/** the Angular version */
	version = VERSION.full;
	/** whether we are production or not */
	envProd = environment.production;
	homeNavigationUrl=environment.homeNavigation;
	accountManagerUrl=environment.accountManagerNavigation;
	scrWidth:any
	isDeskTopView:boolean
	isMobView:boolean
	appConfig: Configparams
	private routerSubscription: Subscription;
	@HostListener('window:resize', ['$event'])
	getScreenSize(event?) {
		this.scrWidth = window.innerWidth;
		if (this.scrWidth > 935) {
			this.isDeskTopView = true;
			this.isMobView = false;
		} else  {
			this.isMobView = true;
			this.isDeskTopView = false;
		}
	}
	/** constructor for setting up DI in this component */
	constructor(private readonly router: Router, private readonly configService: ConfigService, private readonly title: Title, private readonly meta: Meta) {
		this.getScreenSize()
	}
	/** this class requires this method to implement the OnInit interface */

	ngOnInit() {
		this.routerSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				this.setSkipLinkUrl(event.urlAfterRedirects);
			});
		localStorage.clear();
		environment.preconnectBaseUrls.forEach((url) => {
			this.loadExternalLink(url);
		});
		this.CollectAppConfigDetails()
	}

	/** Clean up subscriptions when component is destroyed */
	ngOnDestroy() {
		if (this.routerSubscription) {
			this.routerSubscription.unsubscribe();
		}
	}

	/**
	 * setSkipLinkUrl takes in a url string and processes whether
	 * the skipToMain link should be updated to use the new value
	 * @param currentUrl the new url to refer to
	 */
	private setSkipLinkUrl(currentUrl: string) {
		if(!currentUrl.endsWith('#app-content')) {
			this.skipToMain = `${currentUrl}#app-content`;
		}
	}
	CollectAppConfigDetails() {//To load configuration from config file based on US/CA
		this.appConfig = this.configService.getAppConfigValue();
	}

	 loadExternalLink (url: string | undefined)  {
		if (!url) { return; }
		const trustedOrigins: string[] = [
			'https://www.lincoln.com',
			'https://build.ford.com',
			'https://www.cxservices.ford.com',
			'https://code.jquery.com',
			'https://assets.adobedtm.com'
		];
		const index = trustedOrigins.indexOf(url);
		if (index === -1) { return; }
		// Use the hardcoded value from the array by index to break taint chain
		const safeUrl = trustedOrigins[index]; // eslint-disable-line security/detect-object-injection
		const link = document.createElement('link');
		link.rel = 'preconnect';
		link.setAttribute('href', safeUrl);
		document.head.appendChild(link);
}
}
